import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"
import { FC } from "react"
import { DeleteIconButton } from "src/components/ui/iconButtons/DeleteIconButton"
import { EditIconButton } from "src/components/ui/iconButtons/EditIconButton"
import { ILocation } from "src/domain/entities"

export const LocationListView: FC<{
	list: ILocation[]
	onUpdate: (location: ILocation) => void
	onDelete: (location: ILocation) => void
}> = ({ list, onUpdate, onDelete }) => (
	<Table size={"sm"}>
		<Thead>
			<Tr>
				<Th>Name</Th>
				<Th>Note</Th>
				<Th isNumeric>Actions</Th>
			</Tr>
		</Thead>
		<Tbody>
			{list.map((location, i) => (
				<Tr key={i}>
					<Td>{location.name}</Td>
					<Td>{location.note}</Td>
					<Td isNumeric>
						<EditIconButton onClick={() => onUpdate(location)} />
						<DeleteIconButton onClick={() => onDelete(location)} />
					</Td>
				</Tr>
			))}
		</Tbody>
	</Table>
)
